import $ from 'jquery';

// This function is deprecated in favor of addToBagWithData
export function addToBag(productCode, size, count, callbacks, tryOnSize, dateAdded) {
    const data = {
        colorSelect: productCode,
        sizeSelect: size,
        fitItemSizes: tryOnSize,
        count: count || 1,
        dateAdded: dateAdded
    };
    addToBagWithData(data, callbacks);
}

export function addToBagWithData(dataObj, callbacks, addToBagUrl) {
    if (!dataObj){
        return;
    }
    let updateCartProductCount = false;
    if (!addToBagUrl) {
        addToBagUrl = '/r/ajax/AddItemToBag.jsp';
        updateCartProductCount = true;
    }
    const rcProps = window.rcProps || {};
    dataObj.mobile = true;
    if (!dataObj.sectionURL){
        dataObj.sectionURL = rcProps.sectionUrl;
    }
    if (!dataObj.csrfHash){
        dataObj.csrfHash = rcProps.csrfHash;
    }
    if (!dataObj.d){
        dataObj.d = rcProps.department;
    }
    if (!dataObj.contextReferrer){
        dataObj.contextReferrer = document.referrer;
    }
    dataObj.supportReCAPTCHA = true;
    if (dataObj.code && !dataObj.colorSelect) {
        dataObj.colorSelect = dataObj.code;
    }
    if (dataObj.size && !dataObj.sizeSelect) {
        dataObj.sizeSelect = dataObj.size;
    }
    const serializedData = $.param(dataObj);

    let code = dataObj.code;
    let size = dataObj.size;
    if (!code) {
        code = dataObj.colorSelect;
    }
    if (!size) {
        size = dataObj.sizeSelect;
    }

    $.ajax({
        type: 'POST',
        url: addToBagUrl,
        data: serializedData,
        success: function (data) {
            var obj = $.parseJSON(data);
            if (obj.reCAPTCHA) {
                var reCAPTCHAData = $.param({
                    mobile: true
                });
                $.modal({
                    url: "/r/dialog/VerifyHuman.jsp?" + reCAPTCHAData,
                    type: "full",
                    open: null,
                    cache: false,
                    overlayClose: true,
                    triggerOpen: true
                });
            } else if (obj.reachedBagLimit) {
                var limitData = $.param({
                    code: code,
                    size: size,
                    mobile: true
                });
                $.modal({
                    url: "/r/dialog/ShoppingBagLimit.jsp?" + limitData,
                    type: "small",
                    open: null,
                    cache: false,
                    overlayClose: true,
                    triggerOpen: true,
                    onComplete: function () {
                    }
                });
            } else if (obj.success) {

                if (typeof insertRTBHouseAddToCart === 'function') {
                    insertRTBHouseAddToCart(code);
                }

                if (typeof insertCriteoAddToCart === 'function') {
                    insertCriteoAddToCart(code);
                }

                if (typeof iPinYouAddtoCart === 'function'){
                    iPinYouAddtoCart(code);
                }

                if (typeof insertTaboolaAddToCart === 'function') {
                    insertTaboolaAddToCart('add', code);
                }
                if(typeof addToCartPixelGTM === 'function'){
                    addToCartPixelGTM('add',code,obj.msg1,obj.msg5,1,obj.msg2,obj.msg16);
                }

                if(typeof insertTiktokAddToCart === 'function'){
                    insertTiktokAddToCart(code);
                }

                if(typeof insertSnapchatAddToCart === 'function'){
                    insertSnapchatAddToCart(code);
                }


                if (typeof pushAddProductToCordial === 'function') {
                    pushAddProductToCordial(obj.msg1, code, obj.msg5, obj.msg3, obj.msg16, null, obj.msg28, 1, obj.msg29, obj.msg30)
                }

                if (callbacks && typeof callbacks.success === 'function') {
                    callbacks.success(obj);
                }
            }

            if (updateCartProductCount && obj.msg22) {
                const itemCount = parseInt(obj.msg22, 10);
                if (!Number.isNaN(itemCount)) {
                    $("#shopping_bag_count").html(itemCount);
                    if (itemCount === 0) {
                        $('.bag-count--ab').hide();
                    } else {
                        $('.bag-count--ab').show();
                    }
                }
            }

            if (callbacks && typeof callbacks.done === 'function') {
                callbacks.done(obj);
            }
        }
    });
    window.rcProps.ReCAPTCHACallBack = function(){
        addToBagWithData(dataObj, callbacks, addToBagUrl);
    }
}




// WEBPACK FOOTER //
// ./src/scripts/modules/add-to-bag.js